import { ErrorLayout } from 'views/components';
import { Loader } from 'mol-ui';
import { TextErrorDetail } from './styled';
import { config } from 'config';
import isEmpty from 'lodash/isEmpty';
import moment from 'moment';
import { sharedActions } from 'core/Shared';
import { useHistory } from 'react-router-dom';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';
import {
    useDispatch,
    useObjectState,
    useQuery
} from 'hooks';
const { environment, version } = config;

const Error400 = () => {

    const { push, replace } = useHistory();
    const { dangerColor } = useTheme();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const params = useQuery();
    const [data, setData] = useObjectState({
        endpoint: '',
        message: '',
        method: '',
        pathname: ''
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (isEmpty(params)) {
            push('/');
            return;
        }
        const { endpoint, errormessage, message, method, pathname } = params;
        if (!endpoint || !method) {
            push('/');
            return;
        }
        setData({
            endpoint,
            message: decodeURI(message),
            method,
            pathname
        });
        const payload = {
            endpoint: `${ endpoint } _with method_ ${ method.toUpperCase() }`,
            frontend: `${ pathname } _at_ ${ moment().format('DD-MM-YYYY HH:mm:ss') } _v${ version }_`,
            message: decodeURI(errormessage),
            title: `Error 400 detected in ${ environment.toUpperCase() }`
        };
        dispatch(sharedActions.sendError(payload));
        setLoading(false);
        replace('/error400');
    }, [push, replace, setLoading]);

    if (!loading) {
        const { endpoint, message, method, pathname } = data;
        return (
            <ErrorLayout
                code="400"
                color={ dangerColor }
                description={
                    `${ t('Ocurrió un error interno del sistema por lo que su sesión no continuará iniciada') }.
                    ${ t('Ya recibimos una notificación y estamos trabajando para solucionarlo') }.
                ` }
                title={ t('Error del sistema') }
            >
                <TextErrorDetail>
                    { method.toUpperCase() } { endpoint } <br />
                    { moment().format('DD-MM-YYYY HH:mm') } <br />
                    in { pathname } <br />
                    { message }
                </TextErrorDetail>
            </ErrorLayout>
        );
    } else {
        return <Loader type="dots" />;
    }
};

Error400.propTypes = {

};

export default Error400;
